import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormValidatorHelper } from '@newroom-connect/library/helpers';

import { InputPasswordComponent } from '../inputs/input-password/input-password.component';
import { PasswordFormatValidatorComponent } from '../password-format-validator/password-format-validator.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputPasswordComponent,
    PasswordFormatValidatorComponent
  ],
  selector: 'nrc-change-password-form',
  templateUrl: './change-password-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangePasswordFormComponent {
  @Output() public changePasswordEvent = new EventEmitter<{ newPassword: string; }>();

  public changePasswordForm = new FormGroup({
    newPassword: new FormControl('', [Validators.required, FormValidatorHelper.passwordStrength()]),
    newPasswordConfirmation: new FormControl('', [Validators.required])
  });

  /**
   * @constructor
   */
  constructor() {
    // If the value of "newPassword" changes, overwrite the new password confirmation validator.
    this.changePasswordForm.valueChanges
      .pipe(takeUntilDestroyed())
      .subscribe(value => {
        this.changePasswordForm.controls.newPasswordConfirmation.setValidators(
          [Validators.required, FormValidatorHelper.matchesString(value.newPassword ?? '')]
        );

        this.changePasswordForm.controls.newPasswordConfirmation.updateValueAndValidity({ emitEvent: false });
      });
  }

  /**
   * Emit change password event with the current change password form value.
   */
  @HostListener('document:keyup.enter')
  public changePassword(): void {
    if (this.changePasswordForm.valid) {
      this.changePasswordEvent.emit({ newPassword: this.changePasswordForm.controls.newPassword.value ?? '' });
    }
  }
}
